import { CompaniesRegisterPage } from '@/features/companies/pages/companies-register-page';

export const CompaniesRegisterRoute = () => {
  return <CompaniesRegisterPage />;
};
